<template>
  <div>
    <p>
      {{
        ft(
          featureName,
          'reportingChannels.digitalReport.confirmDescription',
          $t,
          {
            organizationTitle: organizationFullName
          }
        )
      }}
    </p>
    <p v-if="email">
      {{
        ft(
          featureName,
          'reportingChannels.digitalReport.confirmDescriptionEmailIncluded',
          $t,
          {
            organizationTitle: organizationFullName,
            email
          }
        )
      }}
    </p>
    <p v-else class="mb-5">
      {{
        ft(
          featureName,
          'reportingChannels.digitalReport.confirmDescriptionEmailNotIncluded',
          $t,
          {
            organizationTitle: organizationFullName
          }
        )
      }}
    </p>
    <div class="confirm-message mt-5" v-html="message"></div>
  </div>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'DigitalReportConfirm',
  extends: LocalizableComponent,
  props: {
    message: {
      type: String,
      required: true,
      default: null
    },
    email: {
      type: String,
      required: false,
      default: null
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    featureName: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.confirm-message {
  border: 1px solid rgb(206, 208, 212);
  border-radius: 3px;
  min-width: 100%;
  min-height: 20rem;
  padding: 1.5rem;
  color: rgb(156, 158, 160);
  font-style: italic;
}
</style>
